import React from 'react';
import PropTypes from 'prop-types';

import P from '@deliveroo/consumer-component-library/components/P';
import Heading from '@deliveroo/consumer-component-library/components/Heading';

import styles from './styles.scss';

const OrderStatusMissedCallModal = ({
  title,
  text,
  canCallRider,
  riderNumber,
  onClickCallRider,
}) => {
  const callRiderText = text.split('{phone}');
  const callRiderTelLink = riderNumber && (
    <button
      type="button"
      className={styles['call-link']}
      key="contactModalTelLink"
      onClick={onClickCallRider}
    >
      {riderNumber}
    </button>
  );

  return (
    <div className={styles.content}>
      <div className={styles['mobile-image']} />
      <Heading level={3} size="medium">
        {title}
      </Heading>
      <P color="grey" size="regular" spacing="medium 0 medium">
        {/* replaces the phone number with a click to call if can call the rider */}
        {canCallRider ? [callRiderText[0], callRiderTelLink, callRiderText[1]] : text}
      </P>
    </div>
  );
};

OrderStatusMissedCallModal.propTypes = {
  /**
   * can call the rider
   */
  canCallRider: PropTypes.bool,
  /**
   * function that calls rider and tracks it
   */
  onClickCallRider: PropTypes.func,
  /**
   * the number to call when clicking call rider
   */
  riderNumber: PropTypes.string,
  /**
   * modal text
   */
  text: PropTypes.string.isRequired,
  /**
   * title of the modal
   */
  title: PropTypes.string.isRequired,
};

OrderStatusMissedCallModal.defaultProps = {
  canCallRider: false,
  onClickCallRider: () => {},
  riderNumber: '',
};

export default OrderStatusMissedCallModal;
